// src/privacypolicy.js
import { Navigate } from 'react-router-dom';

import './App.css';

const privacypolicy = () => {
  return (
    
    <div className="about-page">

      {/* Hero Section */}
    <section className="heronew">
   <img src="img/blogleft.png" className="vectorall-left desktopvector" alt="left vector" />
  <img src="img/m2.png" className="vectorall-left mobilevector" alt="left vector" />
  <div className="hero-content">
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>Privacy Policy</span>
</h1>

  </div>


</section>

  {/* How we got started */}
      <section className="termcondtion-section">
        <h2 className='newsection'>1. Introduction</h2>
        <p>At Paushtikk Switch Private Limited, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website or use our services. By accessing our website and using our services, you agree to the terms of this Privacy Policy.</p>
<br/>
<h2 className='newsection'>2. Information We Collect</h2>
<p>We may collect and process the following types of information:<br/>
- Personal Information: Name, email address, phone number, delivery address, payment information, and other details provided during registration or while using our services.<br/>
- Technical Information: IP address, browser type, operating system, and other technical details collected through cookies and similar technologies.<br/>
- Usage Information: Information about how you use our website and services, including pages visited, time spent on the site, and other interaction data.<br/>
- By providing your personal information to Paushtikk Switch, you expressly consent to being contacted via WhatsApp, RCS, email, phone calls, SMS, and other digital communication channels for purposes including order updates, service-related communication, customer support, marketing, promotional offers, and important business notifications. You may withdraw your consent or opt out of marketing communications at any time by following the unsubscribe instructions provided or by contacting us directly.</p>      
      <br/>
      <h2 className='newsection'>2A. Health Data</h2>
<p>In addition to the above, we may collect and process certain health-related information that you voluntarily provide while using our services. This may include:<br/>
- Dietary preferences and restrictions (e.g., vegetarian, vegan, allergies, intolerances).<br/>
- Nutrition-related information (e.g., calorie goals, macro preferences, meal choices).<br/>
- Basic health and wellness details (e.g., weight goals, activity levels, lifestyle inputs).</p>  
<br/>
<h4>Purpose of collection:</h4>   
<br/>
<p>- Customize and deliver meal plans suited to your health and nutrition needs.<br/>
   - Provide insights and progress tracking related to your wellness journey.<br/>
   - Improve our services, menu curation, and app functionality.</p> 
<br/>
<h4>How your health data is used:</h4>   
<br/>
<p>- Health data is used only for personalization and app functionality.<br/>
   - We do not sell, rent, or share your health data with advertisers or unrelated third parties.<br/>
   - Limited, anonymized, and aggregated health data may be used internally for analytics and service improvement.</p> 
      <br/>
<h4>Your rights and control over health data:</h4>   
<br/>
<p>- You may choose not to provide health data, though certain features may be limited.<br/>
   - You may request deletion of your health data at any time by contacting us at makemeswitch@paushtikkswitch.com.<br/>
   - We ensure your data is transmitted securely and stored with strict confidentiality measures.</p> 
      <br/>
<h2 className='newsection'>3. How We Use Your Information</h2>
<p>We use the information we collect for various purposes, including:<br/>
- To provide, operate, and maintain our services.<br/>
- To process transactions and send related information, such as order confirmations and invoices.<br/>
- To communicate with you, including sending promotional materials and updates.<br/>
- To personalize your experience and tailor our services to your preferences.<br/>
- To improve our website, services, and overall user experience.<br/>
- To detect, prevent, and address technical issues and security threats.</p>
 <br/>
<h2 className='newsection'>4. Sharing Your Information</h2>
<p>We may share your personal information in the following circumstances:<br/>
- Service Providers: With third-party vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.<br/>
- Legal Requirements: To comply with applicable laws, regulations, legal processes, or governmental requests.<br/>
- Business Transfers: In connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business.</p>
 <br/>
<h2 className='newsection'>5. Data Security</h2>
<p>We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, use, disclosure, alteration, or destruction. However, please be aware that no method of transmission over the Internet or method of electronic storage is completely secure.</p>
 <br/>
<h2 className='newsection'>6. Your Rights</h2>
<p>Depending on your location, you may have the following rights regarding your personal information:<br/>
- Access: The right to request access to the personal information we hold about you.<br/>
- Correction: The right to request correction of inaccurate or incomplete personal information.<br/>
- Deletion: The right to request the deletion of your personal information, subject to certain exceptions.<br/>
- Objection: The right to object to the processing of your personal information in certain circumstances.<br/>
- Data Portability: The right to request the transfer of your personal information to another service provider.<br/>
To exercise any of these rights, please contact us at makemeswitch@paushtikkswitch.com.</p>
<br/>
<h2 className='newsection'>7. Cookies and Tracking Technologies</h2>
<p>We use cookies and similar tracking technologies to track the activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some parts of our services.</p> 
<br/>
<h2 className='newsection'>8. Changes to This Privacy Policy</h2>
<p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.</p>
<br/>
<h2 className='newsection'>9. Contact Us</h2>
<p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:<br/>
Paushtikk Switch Private Limited<br/>
Email: makemeswitch@paushtikkswitch.com<br/>
Phone: +91 8261931481<br/>
Website: www.paushtikkswitch.com</p>
<br/>
GST NO: 27AAMCP7324F1Z8
      </section>

    </div>
  );
};

export default privacypolicy;